export const MEDIA_TYPE = {
  MOVIE: "movie",
  TVSHOWS: "tv",
};

export const ERROR_PAGE = "error";

export const values = {
  MEDIA_TYPE,
  ERROR_PAGE,
};
